import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-document-upload-progress',
    templateUrl: './document-upload-progress.component.html',
    styleUrls: ['./document-upload-progress.component.scss'],
    standalone: false
})
export class DocumentUploadProgressComponent implements OnInit {
  @Input() progress = 0;
  constructor() {}

  ngOnInit() {}
}